export var Name = 'express-checkout-button-click';
export var ExpressCheckoutButtonClick = Name;